// Single source of truth for the app's grouped left-navigation menu.
// Mirrors suggee-admin's appMenu.ts, simplified to jewellery-admin's role model
// (roles: 'Admin' / 'Staff', plus a power-user flag).
//
// Routes are stored WITHOUT a leading slash; the sidebar prepends '/'.
// Each item carries:
//   - `roles`:         which roles may see it (case-insensitive; omit = any logged-in user)
//   - `powerUserOnly`: visible only to the power-user account

export const BRAND_NAME = 'Vinayaka Jewellers';

export interface MenuItem {
  label: string;
  icon: string;
  route: string;
  roles?: string[];
  powerUserOnly?: boolean;
}

export interface MenuGroup {
  category: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  items: MenuItem[];
}

export const APP_MENU_GROUPS: MenuGroup[] = [
  {
    category: 'Product Management',
    icon: 'pi pi-box',
    iconBg: '#fffbeb',
    iconColor: '#f59e0b',
    items: [
      { label: 'Add Product', icon: 'pi pi-plus', route: 'products/add' },
      { label: 'View Products', icon: 'pi pi-list', route: 'products' },
    ],
  },
  {
    category: 'Invoice Management',
    icon: 'pi pi-wallet',
    iconBg: '#ecfdf5',
    iconColor: '#10b981',
    items: [
      { label: 'Create Invoice', icon: 'pi pi-plus', route: 'invoices/create' },
      { label: 'View Invoices', icon: 'pi pi-list', route: 'invoices' },
    ],
  },
  {
    category: 'Category Management',
    icon: 'pi pi-tags',
    iconBg: '#f5f3ff',
    iconColor: '#8b5cf6',
    items: [
      { label: 'Manage Categories', icon: 'pi pi-list', route: 'categories', roles: ['Admin'] },
    ],
  },
  {
    category: 'Settings',
    icon: 'pi pi-cog',
    iconBg: '#f8fafc',
    iconColor: '#64748b',
    items: [
      { label: 'Register User', icon: 'pi pi-user-plus', route: 'signup', powerUserOnly: true },
      { label: 'Set Silver Price', icon: 'pi pi-sliders-h', route: 'settings', roles: ['Admin', 'Staff'] },
    ],
  },
];

// Returns only the groups/items the given role/power-user may see (empty groups dropped).
// Same logic the Home dashboard cards used previously — just relocated.
export function filterMenuForUser(role: string, isPowerUser: boolean): MenuGroup[] {
  const r = (role || '').trim().toLowerCase();
  return APP_MENU_GROUPS
    .map(g => ({
      ...g,
      items: g.items.filter(it => {
        if (it.powerUserOnly && !isPowerUser) return false;
        if (it.roles && !it.roles.map(x => x.toLowerCase()).includes(r)) return false;
        return true;
      }),
    }))
    .filter(g => g.items.length > 0);
}
